@if (alarm) {
  <form
    class="alarm-status-update-form"
    [formGroup]="updateForm">

    <div class="alarm-status-summary">
      <h3>
        {{ actionText }}
      </h3>

      <p>
        {{ alarm.message }}
      </p>

      <span>
        {{ getDeviceNumber(alarm.device_id) }}
      </span>
    </div>

    <app-input-textarea [formData]="commentConfig"  />

    <app-input-image [formData]="imageConfig" class="upload-box" />

    <div class="dialog-actions">
      <app-button-icon
        [label]="loading ? ('common.messages.info.please-wait' | translateSafe) : actionLabel"
        iconName="check_circle"
        class="iconless"
        [disabled]="loading"
        (click)="onSubmit()" />

      <app-button-icon
        [label]="'common.actions.cancel' | translateSafe"
        iconName="close"
        class="iconless secondary"
        [disabled]="loading"
        (click)="onCloseClick()" />
    </div>
  </form>
}
